import type { ParsedTable } from '../types'
import { toNumber } from '../generators/helpers'

/**
 * Validates if the parsed table data is suitable for rendering a Bar or Column chart
 * These chart types require the user to select a specific data column (header)
 *
 * Checks:
 * - At least one row exists
 * - At least one data column exists (header count > 1)
 * - At least one numeric data point exists in any of the data columns
 *
 * @param t - The parsed table data
 * @returns True if the data could be rendered as a bar/column chart (pending header selection), false otherwise
 */
export function canRenderBarColumn(t: ParsedTable): boolean {
  if (t.rowCnt === 0 || t.colCnt < 2) {
    return false
  }

  // Check if there is at least one valid numeric data point in any data column
  for (let r = 0; r < t.rowCnt; r++) {
    for (let c = 1; c < t.colCnt; c++) {
      if (t.rows[r] && c < t.rows[r].length) {
        const num = toNumber(t.rows[r][c])
        if (num !== null && !isNaN(num)) {
          return true
        }
      }
    }
  }

  console.warn('canRenderBarColumn: No valid numeric data points found in any data column.')
  return false
}
